var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97069 0.75C3.09126 0.75 0.766391 3.08572 0.761707 5.96997L0.750007 13.1843C0.74547 15.9413 2.88223 18.1719 5.58326 18.3677V22.875C5.58314 22.9493 5.6051 23.022 5.64634 23.0838C5.68759 23.1456 5.74626 23.1937 5.81492 23.2221C5.88358 23.2505 5.95913 23.2579 6.03198 23.2433C6.10484 23.2287 6.17171 23.1928 6.22413 23.1401L10.9475 18.405H18.0418C20.9212 18.405 23.25 16.0699 23.25 13.1851V5.97071C23.25 3.08688 20.9329 0.75 18.0535 0.75H5.97069ZM8.25072 8.45361C8.86759 8.45361 9.37499 8.96179 9.37499 9.57861C9.37498 10.1954 8.86758 10.7036 8.25072 10.7036C7.63386 10.7036 7.12573 10.1954 7.12572 9.57861C7.12572 8.96179 7.63386 8.45361 8.25072 8.45361ZM12 8.45361C12.6169 8.45361 13.125 8.96179 13.125 9.57861C13.125 10.1954 12.6168 10.7036 12 10.7036C11.3831 10.7036 10.875 10.1954 10.875 9.57861C10.875 8.96179 11.3831 8.45361 12 8.45361ZM15.7507 8.45361C16.3676 8.45361 16.8757 8.96179 16.8757 9.57861C16.8757 10.1954 16.3676 10.7036 15.7507 10.7036C15.1339 10.7036 14.625 10.1954 14.625 9.57861C14.625 8.96179 15.1339 8.45361 15.7507 8.45361Z",
    fill: "#5D7285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessages);
export default __webpack_public_path__ + "static/media/new_messages.3d1505c47704c5875e04a4c805bdef6b.svg";
export { ForwardRef as ReactComponent };